import React from 'react';
import PerformanceComparison from './PerformanceComparison';
import S from './Performance.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PeriodPerformance({
  value: periodPerformance
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: S.container,
    children: [/*#__PURE__*/_jsx(PerformanceComparison, {
      metricName: "Sell Through Rate",
      currentValue: periodPerformance?.currentSellThroughRate,
      previousValue: periodPerformance?.previousSellThroughRate,
      isPercentage: true
    }), /*#__PURE__*/_jsx(PerformanceComparison, {
      metricName: "RecovR Sales",
      currentValue: periodPerformance?.currentRecovrSales,
      previousValue: periodPerformance?.previousRecovrSales
    })]
  });
}